import { useCallback, useEffect, useState } from 'react';

const CHROME_HIDDEN_CLASS = 'mpc-chrome-hidden';

/**
 * Hides backoffice header + left drawer while this page is mounted.
 * Default: chrome hidden. Toggle restores/hides without affecting other routes.
 */
export const useMobileChromeGate = (defaultHidden = true) => {
    const [chromeHidden, setChromeHidden] = useState(defaultHidden);

    useEffect(() => {
        const body = document.body;
        if (chromeHidden) {
            body.classList.add(CHROME_HIDDEN_CLASS);
        } else {
            body.classList.remove(CHROME_HIDDEN_CLASS);
        }

        return () => {
            body.classList.remove(CHROME_HIDDEN_CLASS);
        };
    }, [chromeHidden]);

    const toggleChrome = useCallback(() => {
        setChromeHidden((prev) => !prev);
    }, []);

    const hideChrome = useCallback(() => setChromeHidden(true), []);
    const showChrome = useCallback(() => setChromeHidden(false), []);

    return {
        chromeHidden,
        toggleChrome,
        hideChrome,
        showChrome,
    };
};
